module.exports = __webpack_public_path__ + "e6eb15d66abb77678ce756a7e7fa09cf.png";